import { useState } from 'react';
import { pushLeadEventToDataLayer } from '../analytics';
import { postPrivateLead, postPublicLead } from '../fetch';
import type { PostAnonymousLeadRequest } from '../../generated/api/postAnonymousLeadRequest';
import type { PostLeadRequest } from '../../generated/api/postLeadRequest';

export type LeadSubmitStatus = 'IN_PROGRESS' | 'SUCCESS' | 'FAIL';
export type SubmitLeadFn = (request: PostAnonymousLeadRequest | PostLeadRequest) => Promise<boolean>;

const isAnonymousLead = (req: PostAnonymousLeadRequest | PostLeadRequest): req is PostAnonymousLeadRequest => {
  return 'contactDetails' in req;
};

export const useSubmitLead = () => {
  const [leadState, setLeadState] = useState<LeadSubmitStatus | undefined>();

  const submitLead: SubmitLeadFn = async (request: PostAnonymousLeadRequest | PostLeadRequest) => {
    setLeadState('IN_PROGRESS');
    try {
      isAnonymousLead(request) ? await postPublicLead(request) : await postPrivateLead(request);
      pushLeadEventToDataLayer(request.lead.leadType, isAnonymousLead(request));
      setLeadState('SUCCESS');
      return true;
    } catch {
      setLeadState('FAIL');
      return false;
    }
  };

  return { leadState, submitLead };
};
